import React, { useEffect, useState } from 'react';
import { get } from "lodash";
// import { loadState } from '../../store/LocalStorage'
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from 'react-router-dom'

function UpdateIntents(props) {
    // const history=useHistory();
    const navigate = useHistory();
    const [Emotion, setEmotion] = React.useState('');
    const [formData, setName] = useState({ intents: "" });
    const IntId = localStorage.getItem('IntentInfo');
    const [PortalList, setPortalList] = useState([])
    const [PoralId, setPortalId] = React.useState('');
    const [selectPortal, setselectPortal] = useState([])

    const portStatus = localStorage.getItem('PortalStatus');
    // const { IntId, Ques} = get(loadState(), "IntId") || {};
    //console.log("pass id", IntId)
    useEffect(() => {

        LoadIntents();
        LoadPortals();


    }, [])

    const LoadIntents = () => {

        const datavalue = {
            id: IntId
        }
        // const config = {

        //     headers: { 'content-type': 'multipart/form-data' }
        // }
        var authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/getMasterIntentsByid`,
            data: datavalue,
            headers: { 'Content-Type': 'multipart/form-data' },
        };
        axios(authOptions)
            // axios.post(`https://localhost:7261/getIntentsByid`, datavalue, config)
            .then(res => {
                //console.log("get value", res);
                //console.log("list", res.data.result[0].id)
                // setIntentList(res.data)
                setName({ intents: res.data.result[0].Intents });
                setselectPortal(res.data.result[0].Portal_Id)
                setPortalId(res.data.result[0].Portal_Id);

            })
    }
    const LoadPortals = () => {
        axios.get(`${process.env.REACT_APP_API_URL}/GetAllPortal`)
            .then(res => {
                //console.log("list", res.data)
                setPortalList(res.data)
            })
    }
    const handleChangePortal = (event) => {

        setPortalId(event.target.value);
        setselectPortal(event.target.value)
        //console.log("selected Portal", event.target.value)

    };

    const updatesubmit = async (e) => {
        e.preventDefault();

        //console.log("formData", formData)

        let formDataSet = new FormData();
        //formdata object
        if (formData.intents === "" || PoralId == "") {
            if (formData.intents === "") {
                Swal.fire({
                    title: "Error",
                    text: "Question Field Is Required",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }
            if (PoralId === "") {
                Swal.fire({
                    title: "Error",
                    text: "Please Select Portal",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }
        } else {
            formDataSet.append('Intents', formData.intents);  //append the values with key, value pair

            formDataSet.append('id', IntId);
            formDataSet.append('Portal_Id', PoralId == "" ? selectPortal : PoralId)

            // const config = {
            //     headers: { 'content-type': 'multipart/form-data' }
            // }
            var authOptions = {
                method: "post",
                url: `${process.env.REACT_APP_API_URL}/updateMasterIntentsByid`,
                data: formDataSet,
                headers: { 'Content-Type': 'multipart/form-data' },
            };
            axios(authOptions)

                .then(res => {
                    //console.log("get value", res);

                    //console.log("success")
                    // setName({ intents: "", Ans1: "", Ans2: "" });
                    Swal.fire({
                        title: "Success",
                        text: "Intents Update Successfully",
                        icon: "success",
                        confirmButtonText: "Ok",
                    }).then(function () {
                        // window.location.pathname = "/patient-ai/IntentList";
                        // //console.log("not push")
                        // history.push('/IntentList');

                        portStatus ? navigate.push('/PortalMasterIntentList'): navigate.push('/MasterIntentList')
                    });



                })
                .catch(error => {
                    //console.log("error occur", error);
                })
        }

    }
    const BackFunc = () => {
       portStatus ? navigate.push('/PortalMasterIntentList'): navigate.push('/MasterIntentList')
    }

    const handleChange = (e) => {
        setName({ ...formData, [e.target.name]: e.target.value });
    };
    return (
        <>
           <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-middle">
                                {/* <div className="page-title">Add Patient</div> */}
                            </div>
                            <div className=" pull-right">

                                <button type="submit" className="btn btn-primary d-inline-block" onClick={BackFunc}> <i className="fa fa-arrow-left" aria-hidden="true"></i></button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2 col-sm-2">
                        </div>
                        <div className="col-md-8 col-sm-8">
                            <div className="card card-box">
                                <div className="card-head">
                                    <header>Update Intent</header>

                                </div>
                                <div className="card-body " id="bar-parent1">
                                    <form className="register-form" id="login-form" onSubmit={updatesubmit}>

                                        <div className="form-group row">
                                            <label for="horizontalFormEmail"
                                                className="col-sm-3 control-label">Intent</label>
                                            <div className="col-sm-9">

                                            <input type="text"
                                                value={formData.intents}
                                                onChange={handleChange}
                                                name="intents" className="form-control" id="simpleFormEmail"
                                                placeholder="Enter Intent" />
                                            </div>
                                        </div>
                                        <div className="form-group row">

                                            <label for="horizontalFormEmail"
                                                className="col-sm-3 control-label">Portal</label>
                                            <div className="col-sm-9">
                                            <select className="form-control select2" onChange={handleChangePortal} value={selectPortal} disabled>
                                                    <option value="" >--Select--</option>
                                                    {
                                                        PortalList.map((result, i) => {
                                                            return (
                                                                <option value={result.id} key={result.id}>{result.portal_Name}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                            </div>
                                        </div>

                                        <div className='row'>
                                            <div className="col-12 text-end">
                                                <button type="submit" className="btn btn-primary d-inline-block">Submit</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3">
                        </div>
                    </div>

                </div>
            </div>
        </>
    );
}

export default UpdateIntents;